<div class="text-center" style="z-index: 10000;">
  <div style="max-width:350px; z-index:10000;" class="mx-auto">
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="username" class="menu-box-text">Numer rejestracyjny</label>
        <input type="text" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />
        <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
          <div *ngIf="f.username.errors.required">Numer rejestracyjny jest wymagany.</div>
        </div>
      </div>

      <div class="form-group">

        <label for="password" class="menu-box-text">Ostatnie 5 cyfr numeru VIN</label>
        <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />

        <div class="margin-t-10"></div>

        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
          <div *ngIf="f.password.errors.required">Ostatnie 5 cyfr numeru VIN są wymagane</div>
        </div>

      </div>
      <button style="margin-bottom: 20px;" [disabled]="loading" class="btn btn-primary form-control">
        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
        Zaloguj
      </button>

      <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>

      <div>
        <img src="../../../../assets/img/vin-number.png" class="img-responsive"/>
      </div>

      <div>
        Numer <b>VIN</b> znajduje się na pierwszej stronie dowodu rejestracyjnego pojazdu w polu E, zgodnie z powyższą grafiką,
      </div>
    </form>
  </div>
</div>
